/** @format */

import {getNotesCollection} from './getNotesCollection';
import {aggregateScatter} from '../scatter-discreteness/aggregateScatter';
import {ScatterData} from '../../models/scatters';
import {NoteRecordFromQuery} from '../../types';

interface Options {
  data: ReadonlyArray<NoteRecordFromQuery>;
  daysRange: number;
  rechartsDates: string[];
}

const mapNotes = ({data, daysRange, rechartsDates}: Options): ScatterData => {
  return aggregateScatter({
    collection: getNotesCollection(data),
    daysRange,
    rechartsDates,
  });
};

export {mapNotes};
